import { PayloadStates } from '@lore/utils';
import useProjectInvitationsCreated from './useProjectInvitationsCreated';
import useEventInvitationsCreated from './useEventInvitationsCreated';

export default function useInvitationsCreated(network, timestamp) {
  const projectEvaluations = useProjectInvitationsCreated(network, timestamp);
  const eventEvaluations = useEventInvitationsCreated(network, timestamp);

  if (
    projectEvaluations.state === PayloadStates.FETCHING ||
    eventEvaluations.state === PayloadStates.FETCHING
  ) {
    return {
      state: PayloadStates.FETCHING,
      data: [],
      meta: {}
    };
  }

  return {
    state: PayloadStates.RESOLVED,
    meta: {
      totalCount: projectEvaluations.meta.totalCount + eventEvaluations.meta.totalCount
    }
  };
}
